var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.649483 14.6128L6.8269 6.89096L0.610474 0.612793H2.00954L7.45202 6.10943L11.8494 0.612793H16.6105L10.0855 8.76896L15.8717 14.6128H14.4726L9.46037 9.5505L5.41057 14.6128H0.649483ZM2.70692 13.6494H4.89417L14.5527 1.57638H12.3655L2.70692 13.6494Z",
    fill: "#8591A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2f07aa5a183f765c66596ca511739a82.svg";
export { ForwardRef as ReactComponent };